import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const truckStatusesAdapter = getAdapter({ idFieldName: 'text' });

const truckStatusesSlice = createSlice({
  name: 'truckStatuses',
  initialState: truckStatusesAdapter.getInitialState(),
  reducers: {
    setTruckStatuses: (state, { payload: { truckStatuses } }) => {
      truckStatusesAdapter.setAll(state, truckStatuses);
    },
  },
});

const selectors = truckStatusesAdapter.getSelectors(({ truckStatuses }) => truckStatuses);

export const getTruckStatuses = (state) => selectors.selectAll(state);

export const {
  setTruckStatuses,
} = truckStatusesSlice.actions;

export default truckStatusesSlice.reducer;
